// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconCircleArrowRight = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 32C8 46.809 17.191 56 32 56C46.809 56 56 46.809 56 32C56 17.191 46.809 8 32 8C17.191 8 8 17.191 8 32ZM35.6962 18.0311C36.3429 18.7253 47.021 30.3339 47.6206 30.9775C48.2203 31.621 48.2203 32.3789 47.6206 33.0225C47.021 33.6661 36.3429 45.2747 35.6961 45.9689C35.0494 46.663 34.2089 46.6779 33.538 46.007C32.8671 45.3361 32.5174 44.9865 31.8466 44.3156C31.1757 43.6447 31.1905 42.8042 31.8846 42.1574C32.3334 41.7394 37.3716 37.1028 40.8801 33.8745C35.0425 34.1617 18.3362 34.9816 17.5518 34.9995C16.6007 35.0211 16 34.4338 16 33.4825V30.5175C16 29.5662 16.6007 28.9789 17.5518 29.0005C18.3362 29.0184 35.0427 29.8383 40.8802 30.1254C37.3717 26.8972 32.3335 22.2606 31.8848 21.8425C31.1906 21.1957 31.1758 20.3553 31.8467 19.6844C32.5175 19.0135 32.8671 18.6639 33.538 17.993C34.2089 17.3221 35.0494 17.337 35.6962 18.0311Z" />
    </svg>
  );
};
